import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';
import { Contract } from '@/types/ContractType';

export const PartiesInfo = ({ contract }: { contract: Contract }) => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>PARTIES CONTACT INFORMATION</Text>
      <View>
        <Text style={styles.bold}>Buyer Contact Information</Text>
        <View>
          <Text>
            • Email Address:{' '}
            <Text style={styles.subSection}>
              {contract?.buyerInfo?.email ?? 'N/A'}
            </Text>
          </Text>
          {contract?.buyerInfo?.email2 && (
            <Text>
              • Email Address:{' '}
              <Text style={styles.subSection}>
                {contract?.buyerInfo?.email2 ?? 'N/A'}&{' '}
                {contract?.buyerInfo?.email ?? 'N/A'}
              </Text>
            </Text>
          )}
          <Text>
            • Phone Number:{' '}
            <Text style={styles.subSection}>
              {contract?.buyerInfo?.phone ?? 'N/A'}
            </Text>
          </Text>
          {contract?.buyerInfo?.phone2 && (
            <Text>
              • Phone Number:{' '}
              <Text style={styles.subSection}>
                {contract?.buyerInfo?.phone2 ?? 'N/A'}&{' '}
                {contract?.buyerInfo?.phone ?? 'N/A'}
              </Text>
            </Text>
          )}
        </View>

        <Text style={styles.bold}>Seller Contact Information:</Text>
        <View>
          {contract?.sellerInfo?.email2 && (
            <Text>
              • Email Address:{' '}
              <Text style={styles.subSection}>
                {contract?.sellerInfo?.email2 ?? 'N/A'} &{' '}
                {contract?.sellerInfo?.email2 ?? 'N/A'}
              </Text>
            </Text>
          )}
          <Text>
            • Phone Number:{' '}
            {contract?.sellerInfo?.phone && (
              <Text>
                <Text style={styles.subSection}>
                  {contract?.sellerInfo?.phone2 ?? 'N/A'}
                </Text>
              </Text>
            )}
            <Text style={styles.subSection}>
              & {contract?.sellerInfo?.phone ?? 'N/A'}
            </Text>
          </Text>
        </View>
      </View>
    </View>
  );
};
